<app-side-menu>
  <div class="service-order-form-container">
    <div class="page-header">
      <div class="header-content">
        <div class="header-title">
          <i class="fas fa-clipboard-list"></i>
          <h1>{{ getFormTitle() }}</h1>
        </div>
        <button class="btn btn-secondary" (click)="onCancel()">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>
      </div>
    </div>

    <div class="form-content">
      <div *ngIf="loading" class="loading-container">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>

      <form [formGroup]="serviceOrderForm" (ngSubmit)="onSubmit()" *ngIf="!loading">
        
        <!-- NAVEGAÇÃO DAS ABAS (FormShell) -->
        <div class="tabs-container">
          <app-form-shell
            [tabs]="serviceOrderTabs"
            [activeTab]="activeTabId"
            (tabChange)="onServiceOrderTabChange($event)">
          </app-form-shell>
        </div>

        <!-- STEP 1: Abertura -->
        <div *ngIf="currentStep === 1" class="step-content">
          <!-- SEÇÃO: Seleção do Tipo de OS -->
          <div class="form-section">
            <h3 class="section-title">
              <i class="fas fa-play-circle"></i> Abertura da Ordem de Serviço
            </h3>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="tipoOS">Tipo de OS <span class="required">*</span></label>
                  <select 
                    id="tipoOS" 
                    class="form-control" 
                    formControlName="tipoOS"
                    (change)="onTipoOSChange()"
                    [class.is-invalid]="serviceOrderForm.get('tipoOS')?.invalid && serviceOrderForm.get('tipoOS')?.touched"
                    [attr.disabled]="osGerada ? true : null">
                    <option value="" *ngIf="!loadingOsTypeConfigs">Selecione o tipo de ordem de serviço</option>
                    <option value="" *ngIf="loadingOsTypeConfigs" disabled>Carregando tipos...</option>
                    <option *ngFor="let cfg of osTypeConfigs; trackBy: trackByOsTypeConfig" [value]="cfg.typeOS">{{ cfg.typeOS }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="serviceOrderForm.get('tipoOS')?.invalid && serviceOrderForm.get('tipoOS')?.touched">
                    Tipo de OS é obrigatório
                  </div>
                  <small class="form-text text-muted" *ngIf="!osGerada">
                    <i class="fas fa-info-circle"></i> Selecione o tipo de ordem de serviço para continuar
                  </small>
                  <small class="form-text text-muted" *ngIf="osGerada">
                    <i class="fas fa-lock"></i> Campo bloqueado após gerar a OS
                  </small>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="motivoAbertura">Motivo da Abertura <span class="required">*</span></label>
                  <select
                    id="motivoAbertura"
                    class="form-control"
                    formControlName="motivoAbertura"
                    [class.is-invalid]="serviceOrderForm.get('motivoAbertura')?.invalid && serviceOrderForm.get('motivoAbertura')?.touched"
                    [attr.disabled]="osGerada ? true : null">
                    <option value="" *ngIf="loadingMotivoAberturaOptions" disabled>Carregando motivos...</option>
                    <option value="" *ngIf="!loadingMotivoAberturaOptions">Selecione o motivo da abertura</option>
                    <option *ngFor="let motivo of motivoAberturaOptions" [value]="motivo">{{ motivo }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="serviceOrderForm.get('motivoAbertura')?.invalid && serviceOrderForm.get('motivoAbertura')?.touched">
                    Motivo da abertura é obrigatório
                  </div>
                  <small class="form-text text-muted" *ngIf="!osGerada">
                    <i class="fas fa-info-circle"></i> Informe o motivo da abertura para gerar a OS
                  </small>
                  <small class="form-text text-muted" *ngIf="osGerada">
                    <i class="fas fa-lock"></i> Campo bloqueado após gerar a OS
                  </small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <button 
                  type="button" 
                  class="btn btn-success btn-lg w-100"
                  (click)="gerarOS()"
                  [disabled]="!serviceOrderForm.get('tipoOS')?.value || !serviceOrderForm.get('motivoAbertura')?.value || osGerada || gerandoOS">
                  <i class="fas fa-spinner fa-spin" *ngIf="gerandoOS"></i>
                  <i class="fas fa-plus-circle" *ngIf="!gerandoOS && !osGerada"></i>
                  <i class="fas fa-check-circle" *ngIf="!gerandoOS && osGerada"></i>
                  {{ gerandoOS ? 'Gerando...' : (osGerada ? 'OS Gerada' : 'Gerar OS') }}
                </button>
              </div>
            </div>
            
            <!-- Toggle e campo de Data de Conclusão -->
            
          </div>

          <!-- SEÇÃO: Status da OS -->
          <div class="form-section" *ngIf="osGerada">
            <h3 class="section-title">
              <i class="fas fa-check-circle"></i> OS Gerada com Sucesso
            </h3>
            <div class="alert alert-success">
              <h5><i class="fas fa-check"></i> Ordem de Serviço Criada</h5>
              <p class="mb-2">A ordem de serviço foi gerada com sucesso! Agora você pode navegar pelas outras abas para preencher as informações necessárias.</p>
              <div class="row">
                <div class="col-md-4">
                  <strong>Tipo:</strong> {{ serviceOrderForm.get('tipoOS')?.value }}<br>
                  <strong>Número:</strong> {{ serviceOrderForm.get('numeroOS')?.value }}
                </div>
                <div class="col-md-4">
                  <strong>Data:</strong> {{ serviceOrderForm.get('dataAbertura')?.value }}<br>
                  <strong>Hora:</strong> {{ serviceOrderForm.get('horaAbertura')?.value }}
                </div>
                <div class="col-md-4">
                  <strong>Setor:</strong> {{ serviceOrderForm.get('setorAbertura')?.value }}<br>
                  <strong>Usuário:</strong> {{ serviceOrderForm.get('usuarioNome')?.value }}<br>
                  <strong>Motivo:</strong> {{ serviceOrderForm.get('motivoAbertura')?.value || 'N/A' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 2: Informações Gerais -->
        <div *ngIf="currentStep === 2" class="step-content">
        <!-- SEÇÃO: Ações Rápidas -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-bolt"></i> Ações Rápidas
          </h3>
          <div class="quick-actions-container">
            <button 
              type="button" 
              class="btn btn-primary btn-direcionar" 
              (click)="direcionarParaSetor()"
              *ngIf="isTransactionOS()">
              <i class="fas fa-share"></i>
              {{ isViewMode ? 'Transitar OS' : 'Direcionar para Área' }}
            </button>
            
            <button 
              type="button" 
              class="btn btn-info btn-imprimir" 
              (click)="imprimirOS()">
              <i class="fas fa-print"></i> Imprimir OS
            </button>
            
            <button 
              type="button" 
              class="btn btn-danger btn-encerrar" 
              (click)="encerrarOS()"
              *ngIf="canCloseSection()">
              <i class="fas fa-check-circle"></i> Encerrar OS
            </button>
          </div>
        </div>

        <!-- SEÇÃO: Status Atual da OS -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-clipboard-check"></i> Status Atual da OS
          </h3>
          <div class="status-stickers-container">
            <div class="status-sticker">
              <div class="sticker-icon">
                <i class="fas fa-tools"></i>
              </div>
              <div class="sticker-content">
                <div class="sticker-label">Status</div>
                <div class="sticker-value">{{ serviceOrderForm.get('statusAtual')?.value || 'Não definido' }}</div>
              </div>
            </div>
            
            <div class="status-sticker">
              <div class="sticker-icon">
                <i class="fas fa-building"></i>
              </div>
              <div class="sticker-content">
                <div class="sticker-label">Setor Atual</div>
                <div class="sticker-value">{{ serviceOrderForm.get('setorAtual')?.value || 'Mecânica' }}</div>
              </div>
            </div>
            
            <div class="status-sticker" *ngIf="serviceOrderForm.get('motivoStatus')?.value">
              <div class="sticker-icon">
                <i class="fas fa-info-circle"></i>
              </div>
              <div class="sticker-content">
                <div class="sticker-label">Motivo</div>
                <div class="sticker-value">{{ serviceOrderForm.get('motivoStatus')?.value }}</div>
              </div>
            </div>
            
            <div class="status-sticker">
              <div class="sticker-icon">
                <i class="fas fa-cogs"></i>
              </div>
              <div class="sticker-content">
                <div class="sticker-label">Tipo da OS</div>
                <div class="sticker-value">{{ getDisplayTipoOS() || 'Não definido' }}</div>
              </div>
            </div>

            <div class="status-sticker" *ngIf="serviceOrderForm.get('dataConclusao')?.value">
              <div class="sticker-icon">
                <i class="fas fa-calendar-check"></i>
              </div>
              <div class="sticker-content">
                <div class="sticker-label">Data de Conclusão</div>
                <div class="sticker-value">
                  {{ formatarDataConclusao(serviceOrderForm.get('dataConclusao')?.value) }}
                  <span *ngIf="serviceOrderForm.get('horaConclusao')?.value">às {{ serviceOrderForm.get('horaConclusao')?.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SEÇÃO: Dados Automáticos -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-info-circle"></i> Dados Automáticos
          </h3>
          <div class="row">
            <div class="col-md-4 col-lg-3">
              <div class="form-group">
                <label for="numeroOS">Número da OS <span class="required">*</span></label>
                <input 
                  type="text" 
                  id="numeroOS" 
                  class="form-control form-control-readonly" 
                  formControlName="numeroOS"
                  readonly
                  title="Número gerado automaticamente">
                <small class="form-text text-muted">
                  <i class="fas fa-info-circle"></i> Gerado automaticamente
                </small>
              </div>
            </div>

            <div class="col-md-4 col-lg-3">
              <div class="form-group">
                <label for="usuarioLogado">Usuário Logado <span class="required">*</span></label>
                <input 
                  type="text" 
                  id="usuarioLogado" 
                  class="form-control form-control-readonly" 
                  [value]="getDisplayLoggedUser()"
                  readonly
                  title="Usuário logado">
                <small class="form-text text-muted">
                  <i class="fas fa-user"></i> Usuário logado
                </small>
              </div>
            </div>

            <div class="col-md-4 col-lg-3">
              <div class="form-group">
                <label for="dataAbertura">Data de Abertura <span class="required">*</span></label>
                <input 
                  type="date" 
                  id="dataAbertura" 
                  class="form-control form-control-readonly" 
                  formControlName="dataAbertura"
                  readonly
                  title="Data de abertura automática">
                <small class="form-text text-muted">
                  <i class="fas fa-calendar"></i> Data automática
                </small>
              </div>
            </div>

            <div class="col-md-4 col-lg-3">
              <div class="form-group">
                <label for="horaAbertura">Hora de Abertura <span class="required">*</span></label>
                <input 
                  type="time" 
                  id="horaAbertura" 
                  class="form-control form-control-readonly" 
                  [value]="getDisplayOpeningHour()"
                  readonly
                  title="Hora de abertura automática">
                <small class="form-text text-muted">
                  <i class="fas fa-clock"></i> Hora automática
                </small>
              </div>
            </div>

          </div>
        </div>

        </div>

        <!-- STEP 3: Veículo -->
        <div *ngIf="currentStep === 3" class="step-content">
        <!-- SEÇÃO: Informações Básicas do Veículo -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-car"></i> Informações Básicas do Veículo
          </h3>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="veiculoPlaca">Veículo</label>
                <div class="input-with-icon">
                  <input 
                    type="text" 
                    id="veiculoPlaca" 
                    class="form-control form-control-readonly" 
                    formControlName="veiculoPlaca"
                    placeholder="Nenhum veículo selecionado"
                    readonly>
                  <button 
                    type="button" 
                    class="btn-search-icon" 
                    (click)="openVehicleModal()"
                    *ngIf="!isViewMode && canVehicleSection()"
                    title="Buscar veículo">
                    <i class="fas fa-search"></i>
                  </button>
                  <span
                    *ngIf="!canVehicleSection()"
                    class="btn-search-icon btn-search-icon--locked"
                    title="Veículo bloqueado pela configuração da OS">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
                <small class="form-text text-muted" *ngIf="!serviceOrderForm.get('veiculoPlaca')?.value && canVehicleSection()">
                  <i class="fas fa-info-circle"></i> Clique na lupa para selecionar um veículo
                </small>
                <small class="form-text text-warning" *ngIf="!canVehicleSection()">
                  <i class="fas fa-lock"></i> Veículo não permitido neste tipo de OS
                </small>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="km">KM Atual</label>
                <div class="input-group">
                  <input
                    type="text"
                    id="km"
                    class="form-control"
                    [class.form-control-readonly]="!canEditVehicleKm()"
                    formControlName="km"
                    appNumberMask
                    [decimals]="0"
                    placeholder="Ex: 50.000"
                    [readonly]="!canEditVehicleKm()"
                    [title]="canEditVehicleKm() ? 'KM do cadastro do veículo' : 'Selecione um veículo para editar o KM'">
                  <button type="button" class="btn btn-outline-primary" *ngIf="canEditVehicleKm()"
                          [disabled]="salvandoKmVeiculo" (click)="salvarKmVeiculo()"
                          title="Atualizar o KM no cadastro do veículo">
                    <i class="fas" [ngClass]="salvandoKmVeiculo ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                  </button>
                </div>
                <small class="form-text text-muted">
                  <i class="fas fa-tachometer-alt"></i>
                  {{ canEditVehicleKm()
                    ? 'KM do cadastro do veículo — salve para atualizar o cadastro.'
                    : 'Vincule um veículo à OS para editar o KM.' }}
                </small>
              </div>
            </div>
          </div>

          <div class="alert alert-secondary" *ngIf="serviceOrderForm.get('veiculoId')?.value">
            <i class="fas fa-info-circle"></i>
            Dados do veículo carregados automaticamente e mantidos somente para leitura na OS.
          </div>

          <div class="row" *ngIf="serviceOrderForm.get('veiculoId')?.value">
            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoMarca">Marca</label>
                <input
                  type="text"
                  id="veiculoMarca"
                  class="form-control form-control-readonly"
                  formControlName="veiculoMarca"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoModelo">Modelo</label>
                <input
                  type="text"
                  id="veiculoModelo"
                  class="form-control form-control-readonly"
                  formControlName="veiculoModelo"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoAnoModelo">Ano Modelo</label>
                <input
                  type="text"
                  id="veiculoAnoModelo"
                  class="form-control form-control-readonly"
                  formControlName="veiculoAnoModelo"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoStatusDetalhes">Situação do Veículo</label>
                <input
                  type="text"
                  id="veiculoStatusDetalhes"
                  class="form-control form-control-readonly"
                  formControlName="veiculoStatusDetalhes"
                  readonly>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="serviceOrderForm.get('veiculoId')?.value">
            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoQuilometragemAtual">Quilometragem Atual</label>
                <input
                  type="text"
                  id="veiculoQuilometragemAtual"
                  class="form-control form-control-readonly"
                  formControlName="veiculoQuilometragemAtual"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoUltimaManutencaoData">Última Manutenção</label>
                <input
                  type="text"
                  id="veiculoUltimaManutencaoData"
                  class="form-control form-control-readonly"
                  formControlName="veiculoUltimaManutencaoData"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoUltimaManutencaoKm">KM Última Manutenção</label>
                <input
                  type="text"
                  id="veiculoUltimaManutencaoKm"
                  class="form-control form-control-readonly"
                  formControlName="veiculoUltimaManutencaoKm"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoProximaManutencaoData">Próxima Manutenção</label>
                <input
                  type="text"
                  id="veiculoProximaManutencaoData"
                  class="form-control form-control-readonly"
                  formControlName="veiculoProximaManutencaoData"
                  readonly>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="serviceOrderForm.get('veiculoId')?.value">
            <div class="col-md-3">
              <div class="form-group">
                <label for="veiculoRequerManutencao">Requer Manutenção</label>
                <input
                  type="text"
                  id="veiculoRequerManutencao"
                  class="form-control form-control-readonly"
                  formControlName="veiculoRequerManutencao"
                  readonly>
              </div>
            </div>

            <div class="col-md-9">
              <div class="form-group">
                <label for="veiculoObservacoes">Observações do Veículo</label>
                <textarea
                  id="veiculoObservacoes"
                  class="form-control form-control-readonly"
                  formControlName="veiculoObservacoes"
                  rows="3"
                  readonly></textarea>
              </div>
            </div>
          </div>

          <!-- SEÇÃO: Histórico de Preventivas do Veículo -->
          <div class="preventive-history-section" *ngIf="serviceOrderForm.get('veiculoId')?.value">
            <h3 class="section-title">
              <i class="fas fa-clipboard-check"></i> Histórico de Preventivas
            </h3>

            <div *ngIf="loadingPreventiveHistory" class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <span class="ms-2 text-muted">Carregando histórico de preventivas...</span>
            </div>

            <div *ngIf="!loadingPreventiveHistory && preventiveHistory.length === 0" class="alert alert-info">
              <i class="fas fa-info-circle"></i> Nenhuma preventiva registrada para este veículo.
            </div>

            <div *ngIf="!loadingPreventiveHistory && preventiveHistory.length > 0" class="table-responsive">
              <table class="table table-sm table-striped table-hover preventive-history-table">
                <thead>
                  <tr>
                    <th>Preventiva</th>
                    <th>Status</th>
                    <th>KM Executado</th>
                    <th>Próx. KM</th>
                    <th>Observações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of preventiveHistory; trackBy: trackByPreventiveHistory">
                    <td>{{ item.preventiveMaintenanceName }}</td>
                    <td>
                      <span class="badge"
                        [ngClass]="{
                          'badge-success': item.status === 'Completed',
                          'badge-warning': item.status === 'Pending',
                          'badge-danger': item.status === 'Overdue',
                          'badge-secondary': item.status !== 'Completed' && item.status !== 'Pending' && item.status !== 'Overdue'
                        }">
                        {{ item.status }}
                      </span>
                    </td>
                    <td>{{ item.executedMileage != null ? (item.executedMileage | number:'1.0-0') : '-' }}</td>
                    <td>{{ item.nextExecutionMileage != null ? (item.nextExecutionMileage | number:'1.0-0') : '-' }}</td>
                    <td>{{ item.observations || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          <h3 class="section-title" *ngIf="canAditionalVehicleSection()">
            <i class="fas fa-car-side"></i> Veículo Adicional
            <small style="font-size: 0.8rem; font-weight: normal; color: #6c757d; margin-left: 1rem;">
              (Opcional - para casos especiais)
            </small>
          </h3>
          
          <div class="alert alert-info" *ngIf="canAditionalVehicleSection()">
            <i class="fas fa-info-circle"></i>
            <strong>Quando usar:</strong> Utilize esta seção quando houver necessidade de um veículo adicional durante o serviço, como substituição temporária, aguardando peças, ou outras situações especiais.
          </div>

          <div class="row" *ngIf="canAditionalVehicleSection()">
            <div class="col-md-6">
              <div class="form-group">
                <label for="veiculoAdicionalPlaca">Veículo Adicional</label>
                <div class="input-with-icon">
                  <input 
                    type="text" 
                    id="veiculoAdicionalPlaca" 
                    class="form-control form-control-readonly" 
                    formControlName="veiculoAdicionalPlaca"
                    placeholder="Nenhum veículo adicional selecionado"
                    readonly>
                  <button 
                    type="button" 
                    class="btn-search-icon" 
                    (click)="openVehicleAdditionalModal()"
                    title="Buscar veículo adicional">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
                <small class="form-text text-muted" *ngIf="!serviceOrderForm.get('veiculoAdicionalPlaca')?.value">
                  <i class="fas fa-info-circle"></i> Clique na lupa para selecionar um veículo adicional
                </small>
              </div>
            </div>

            
          </div>

          <!-- Informações do Veículo Adicional Selecionado -->
          <div class="row" *ngIf="canAditionalVehicleSection() && serviceOrderForm.get('veiculoAdicionalPlaca')?.value">
            <div class="col-md-12">
              <div class="alert alert-success">
                <h5><i class="fas fa-check-circle"></i> Veículo Adicional Selecionado</h5>
                <div class="row">
                  <div class="col-md-6">
                    <strong>Placa:</strong> {{ serviceOrderForm.get('veiculoAdicionalPlaca')?.value }}
                  </div>
                  <div class="col-md-6">
                    <button 
                      type="button" 
                      class="btn btn-danger btn-sm" 
                      (click)="removerVeiculoAdicional()"
                      *ngIf="!isViewMode"
                      title="Remover veículo adicional">
                      <i class="fas fa-times"></i> Remover Veículo Adicional
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- STEP 4: Responsáveis -->
        <div *ngIf="currentStep === 4" class="step-content">
        <!-- SEÇÃO: Cliente e Contrato -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-users"></i> Cliente e Contrato
          </h3>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="clienteNome">Cliente</label>
                <div class="input-with-icon">
                  <input 
                    type="text" 
                    id="clienteNome" 
                    class="form-control form-control-readonly" 
                    formControlName="clienteNome"
                    placeholder="Nenhum cliente selecionado"
                    readonly>
                  <button 
                    type="button" 
                    class="btn-search-icon" 
                    (click)="openCustomerModal()"
                    *ngIf="!isViewMode && canClientSection()"
                    title="Buscar cliente">
                    <i class="fas fa-search"></i>
                  </button>
                  <span
                    *ngIf="!canClientSection()"
                    class="btn-search-icon btn-search-icon--locked"
                    title="Cliente bloqueado pela configuração da OS">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
                <small class="form-text text-muted" *ngIf="!serviceOrderForm.get('clienteNome')?.value && canClientSection()">
                  <i class="fas fa-info-circle"></i> Opcional - Preenchido automaticamente se veículo estiver locado
                </small>
                <small class="form-text text-warning" *ngIf="!canClientSection()">
                  <i class="fas fa-lock"></i> Cliente não permitido neste tipo de OS
                </small>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="clienteDocumento">CPF / CNPJ</label>
                <input 
                  type="text" 
                  id="clienteDocumento" 
                  class="form-control form-control-readonly" 
                  formControlName="clienteDocumento"
                  placeholder="-"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="clienteCategoria">Categoria</label>
                <input 
                  type="text" 
                  id="clienteCategoria" 
                  class="form-control form-control-readonly" 
                  formControlName="clienteCategoria"
                  placeholder="-"
                  readonly>
              </div>
            </div>
          </div>

          <!-- Contrato -->
          <div class="row" *ngIf="serviceOrderForm.get('contratoId')?.value">
            <div class="col-md-3">
              <div class="form-group">
                <label for="contratoNumero">Contrato Nº</label>
                <input 
                  type="text" 
                  id="contratoNumero" 
                  class="form-control form-control-readonly" 
                  formControlName="contratoNumero"
                  placeholder="Nenhum contrato vinculado"
                  readonly>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label for="contratoStatus">Status</label>
                <input 
                  type="text" 
                  id="contratoStatus" 
                  class="form-control form-control-readonly" 
                  formControlName="contratoStatus"
                  readonly>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label for="contratoDataInicio">Início</label>
                <input 
                  type="text" 
                  id="contratoDataInicio" 
                  class="form-control form-control-readonly" 
                  formControlName="contratoDataInicio"
                  readonly>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label for="contratoDataFim">Fim</label>
                <input 
                  type="text" 
                  id="contratoDataFim" 
                  class="form-control form-control-readonly" 
                  formControlName="contratoDataFim"
                  readonly>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="contratoProdutoNome">Produto</label>
                <div class="input-group">
                  <input 
                    type="text" 
                    id="contratoProdutoNome" 
                    class="form-control form-control-readonly" 
                    formControlName="contratoProdutoNome"
                    readonly>
                  <span class="input-group-text" *ngIf="serviceOrderForm.get('contratoProdutoAtivo')?.value">
                    <i class="fas fa-circle" 
                       [style.color]="serviceOrderForm.get('contratoProdutoAtivo')?.value === 'Sim' ? '#28a745' : '#dc3545'"
                       [title]="serviceOrderForm.get('contratoProdutoAtivo')?.value === 'Sim' ? 'Produto Ativo' : 'Produto Inativo'"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="!serviceOrderForm.get('contratoId')?.value">
            <div class="col-md-6">
              <div class="form-group">
                <label for="contratoNumero">Contrato</label>
                <input 
                  type="text" 
                  id="contratoNumero" 
                  class="form-control form-control-readonly" 
                  formControlName="contratoNumero"
                  placeholder="Nenhum contrato vinculado"
                  readonly>
                <small class="form-text text-muted">
                  <i class="fas fa-info-circle"></i> Preenchido automaticamente ao vincular cliente ou veículo com contrato
                </small>
              </div>
            </div>
          </div>

          <!-- Contrato B2B / ciclo operacional (opcional) -->
          <div class="row mt-3">
            <div class="col-12">
              <h5 class="text-muted mb-3">
                <i class="fas fa-building me-2"></i>
                Contrato B2B / ciclo operacional
                <small class="fw-normal">(opcional)</small>
              </h5>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="b2bContractId">ID Contrato B2B</label>
                <input type="number" id="b2bContractId" class="form-control" formControlName="b2bContractId"
                  [readonly]="isViewMode" placeholder="Ex: 123">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="b2bContractItemId">ID Item B2B</label>
                <input type="number" id="b2bContractItemId" class="form-control" formControlName="b2bContractItemId"
                  [readonly]="isViewMode" placeholder="Ex: 456">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="fuelLevel">Nível combustível</label>
                <input type="text" id="fuelLevel" class="form-control" formControlName="fuelLevel"
                  [readonly]="isViewMode" placeholder="Ex: 1/2, Cheio">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="openingMileage">KM abertura</label>
                <input type="number" id="openingMileage" class="form-control" formControlName="openingMileage"
                  [readonly]="isViewMode" placeholder="KM">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="entryDate">Entrada</label>
                <input type="date" id="entryDate" class="form-control" formControlName="entryDate" [readonly]="isViewMode">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="startWorkDate">Início serviço</label>
                <input type="date" id="startWorkDate" class="form-control" formControlName="startWorkDate" [readonly]="isViewMode">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="deadlineDate">Prazo</label>
                <input type="date" id="deadlineDate" class="form-control" formControlName="deadlineDate" [readonly]="isViewMode">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="endWorkDate">Fim serviço</label>
                <input type="date" id="endWorkDate" class="form-control" formControlName="endWorkDate" [readonly]="isViewMode">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="pickupDate">Retirada</label>
                <input type="date" id="pickupDate" class="form-control" formControlName="pickupDate" [readonly]="isViewMode">
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-end">
              <div class="form-check mb-3">
                <input type="checkbox" class="form-check-input" id="isScheduled" formControlName="isScheduled"
                  [disabled]="isViewMode">
                <label class="form-check-label" for="isScheduled">Agendada (IsScheduled)</label>
              </div>
            </div>
          </div>
        </div>

        </div>

        <!-- STEP 5: Serviços -->
        <div *ngIf="currentStep === 5" class="step-content">

        <!-- Label: Ordem de Serviço de Terceiros -->
        <div class="alert alert-warning" *ngIf="isThirdPartyOS()">
          <i class="fas fa-exchange-alt"></i>
          <strong>Ordem de Serviço de Terceiros</strong>
        </div>

        <!-- SEÇÃO: Serviços -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-tools"></i> Serviços
          </h3>
          
          <!-- Mini-tabela de Serviços -->
          <div class="mini-table-container">
            <div class="mini-table-header">
              <h5><i class="fas fa-wrench"></i> Serviços Selecionados</h5>
              <div class="header-actions">
                <button 
                  type="button" 
                  class="btn btn-warning btn-sm" 
                  (click)="openProviderModal()"
                  *ngIf="!isViewMode && isThirdPartyOS()">
                  <i class="fas fa-handshake"></i> Selecionar Prestador
                </button>
                <button 
                  type="button" 
                  class="btn btn-success btn-sm" 
                  (click)="adicionarServicoLinha()"
                  *ngIf="!isViewMode && canServicesSection()">
                  <i class="fas" [class.fa-file-invoice-dollar]="isThirdPartyOS()" [class.fa-plus]="!isThirdPartyOS()"></i>
                  {{ isThirdPartyOS() ? 'Adicionar Orçamento' : 'Adicionar Serviço' }}
                </button>
              </div>
            </div>

            <!-- Prestador Selecionado -->
            <div class="alert alert-info d-flex align-items-center justify-content-between" *ngIf="isThirdPartyOS() && selectedProvider">
              <div>
                <i class="fas fa-building me-2"></i>
                <strong>Prestador:</strong> {{ selectedProvider.tradeName }}
                <span class="text-muted ms-2">({{ selectedProvider.companyName }} - CNPJ: {{ selectedProvider.cnpj }})</span>
              </div>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removerPrestador()" *ngIf="!isViewMode">
                <i class="fas fa-times"></i> Remover
              </button>
            </div>
            
            <div class="mini-table-content">
              <table class="table table-sm mini-table">
                <thead>
                  <tr>
                    <th width="40">#</th>
                    <th>Serviço</th>
                    <th width="110" *ngIf="isThirdPartyOS()">Natureza</th>
                    <th width="100">Qtd</th>
                    <th width="120">Valor Unit.</th>
                    <th width="90" *ngIf="canViewChargePercent">% a mais</th>
                    <th width="120">{{ isThirdPartyOS() ? 'Cobrança' : 'Total' }}</th>
                    <th width="100" class="text-center">
                      <span class="avaria-header-icon">⚠️</span>
                      <span class="ms-1">Avaria</span>
                    </th>
                    <th width="100" class="text-center">Status Pagamento</th>
                    <th width="80" *ngIf="!isViewMode">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let servico of servicos; let i = index; trackBy: trackByServico" [class.avaria-row]="servico.isAvaria">
                    <td class="text-center">
                      <span class="badge badge-primary">{{ i + 1 }}</span>
                    </td>
                    <td>
                      <!-- Modo Prestador: input texto livre -->
                      <input 
                        *ngIf="selectedProvider && isThirdPartyOS()"
                        type="text" 
                        class="form-control form-control-sm" 
                        [(ngModel)]="servico.descricao"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="Descrição do serviço"
                        [disabled]="isViewMode">
                      <!-- Modo Normal: dropdown da API -->
                      <select 
                        *ngIf="!selectedProvider || !isThirdPartyOS()"
                        class="form-control form-control-sm" 
                        [(ngModel)]="servico.descricao"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onServicoChange(i)"
                        [disabled]="isViewMode || loadingServicos">
                        <option value="">{{ loadingServicos ? 'Carregando serviços...' : 'Selecione o serviço' }}</option>
                        <option *ngFor="let tipo of tiposServicos; trackBy: trackByServiceType" [value]="tipo.name">
                          {{ tipo.name }} - {{ tipo.category }}
                        </option>
                      </select>
                    </td>
                    <td *ngIf="isThirdPartyOS()">
                      <select
                        class="form-control form-control-sm"
                        [(ngModel)]="servico.maintenanceKind"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onServicoChange(i)"
                        [disabled]="isViewMode">
                        <option value="Corretiva">Corretiva</option>
                        <option value="Preventiva">Preventiva</option>
                      </select>
                    </td>
                    <td>
                      <input 
                        type="number" 
                        class="form-control form-control-sm" 
                        [(ngModel)]="servico.quantidade"
                        [ngModelOptions]="{standalone: true}"
                        min="1"
                        step="1"
                        (input)="onServicoChange(i)"
                        [disabled]="isViewMode">
                    </td>
                    <td>
                      <!-- Modo Prestador: valor editável -->
                      <input 
                        *ngIf="selectedProvider && isThirdPartyOS()"
                        type="number" 
                        class="form-control form-control-sm text-end" 
                        [(ngModel)]="servico.valorUnitario"
                        [ngModelOptions]="{standalone: true}"
                        step="0.01"
                        min="0"
                        placeholder="0,00"
                        (input)="onServicoChange(i)"
                        [disabled]="isViewMode || servico.maintenanceKind === 'Preventiva'">
                      <!-- Modo Normal: valor readonly -->
                      <input 
                        *ngIf="!selectedProvider || !isThirdPartyOS()"
                        type="number" 
                        class="form-control form-control-sm text-end form-control-readonly" 
                        [(ngModel)]="servico.valorUnitario"
                        [ngModelOptions]="{standalone: true}"
                        step="0.01"
                        min="0"
                        (input)="onServicoChange(i)"
                        [disabled]="true"
                        readonly
                        title="Valor unitário não editável">
                    </td>
                    <td *ngIf="canViewChargePercent">
                      <input
                        type="number"
                        class="form-control form-control-sm text-end"
                        [(ngModel)]="servico.chargePercent"
                        [ngModelOptions]="{standalone: true}"
                        min="0"
                        max="1000"
                        step="0.01"
                        placeholder="0"
                        (input)="onServicoChange(i)"
                        [disabled]="isViewMode || servico.maintenanceKind === 'Preventiva'">
                    </td>
                    <td class="text-end">
                      <strong [class.text-danger]="servico.isAvaria">{{ formatarValor(servico.valorTotal) }}</strong>
                    </td>
                    <td class="text-center">
                      <div class="avaria-toggle-container">
                        <label class="toggle-switch">
                          <input 
                            type="checkbox" 
                            [(ngModel)]="servico.isAvaria"
                            [ngModelOptions]="{standalone: true}"
                            (change)="onAvariaChange()"
                            [disabled]="isViewMode">
                          <span class="toggle-slider"></span>
                        </label>
                        <span class="avaria-label" *ngIf="servico.isAvaria">
                          <i class="fas fa-check-circle text-danger"></i>
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span *ngIf="servico.isAvaria" 
                            class="badge cursor-pointer"
                            [class.badge-warning]="servico.statusAvaria === 'Pendente'"
                            [class.badge-success]="servico.statusAvaria === 'Pago'"
                            (click)="alterarStatusAvariaServico(i)"
                            title="Clique para alterar status de pagamento">
                        {{ servico.statusAvaria || 'Pendente' }}
                      </span>
                      <span *ngIf="!servico.isAvaria" class="text-muted">-</span>
                    </td>
                    <td *ngIf="!isViewMode" class="text-center">
                      <button 
                        type="button" 
                        class="btn btn-danger btn-sm" 
                        (click)="removerServico(i)"
                        title="Remover serviço">
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="servicos.length === 0">
                    <td colspan="8" class="text-center text-muted">
                      <i class="fas fa-info-circle"></i> Nenhum serviço adicionado
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-active">
                    <td colspan="4" class="text-end"><strong>Subtotal Serviços:</strong></td>
                    <td class="text-end"><strong>{{ formatarValor(calcularValorTotalServicos()) }}</strong></td>
                    <td colspan="3" *ngIf="!isViewMode"></td>
                    <td colspan="2" *ngIf="isViewMode"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- SEÇÃO: Peças -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-cogs"></i> Peças
          </h3>
          
          <!-- Mini-tabela de Peças -->
          <div class="mini-table-container">
            <div class="mini-table-header">
              <h5><i class="fas fa-box"></i> Peças Selecionadas</h5>
              <div class="header-actions">
                <!-- Prioridade da solicitação de peças (apenas OS Normal) -->
                <div class="me-2" *ngIf="!isThirdPartyOS() && canStockSection()">
                  <select
                    id="stockRequestPriority"
                    class="form-control form-control-sm"
                    formControlName="stockRequestPriority"
                    [disabled]="isViewMode"
                    title="Prioridade da solicitação de peças ao estoque">
                    <option value="Normal">Prioridade: Normal</option>
                    <option value="Alta">Prioridade: Alta</option>
                    <option value="Urgente">Prioridade: Urgente</option>
                  </select>
                </div>

                <!-- STICKER DO ALMOXARIFADO SELECIONADO -->
                <div class="warehouse-sticker-inline" *ngIf="canStockSection() && serviceOrderForm.get('almoxarifadoNome')?.value">
                  <div class="sticker-content-inline">
                    <div class="sticker-icon-inline">
                      <i class="fas fa-warehouse"></i>
                    </div>
                    <div class="sticker-info-inline">
                      <div class="sticker-title-inline">Almoxarifado</div>
                      <div class="sticker-value-inline">{{ serviceOrderForm.get('almoxarifadoNome')?.value }}</div>
                    </div>
                  </div>
                </div>
                
                <button 
                  type="button" 
                  class="btn btn-primary btn-sm" 
                  (click)="adicionarPecaLinha()"
                  *ngIf="!isViewMode && canServicesSection()">
                  <i class="fas fa-plus"></i> Adicionar Peça
                </button>
              </div>
            </div>
            
            <div class="mini-table-content">
              <table class="table table-sm mini-table">
                <thead>
                  <tr>
                    <th width="40">#</th>
                    <th>Peça</th>
                    <th width="110" *ngIf="isThirdPartyOS()">Natureza</th>
                    <th width="100">Qtd</th>
                    <th width="120">Valor Unit.</th>
                    <th width="90" *ngIf="canViewChargePercent">% a mais</th>
                    <th width="120">{{ isThirdPartyOS() ? 'Cobrança' : 'Total' }}</th>
                    <th width="100" class="text-center">
                      <span class="avaria-header-icon">⚠️</span>
                      <span class="ms-1">Avaria</span>
                    </th>
                    <th width="100" class="text-center">Status Pagamento</th>
                    <th width="100" class="text-center" *ngIf="canStockSection()">Em Estoque</th>
                    <th width="80" *ngIf="!isViewMode">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let peca of pecas; let i = index; trackBy: trackByPeca" [class.avaria-row]="peca.isAvaria">
                    <td class="text-center">
                      <span class="badge badge-secondary">{{ i + 1 }}</span>
                    </td>
                    <td>
                      <!-- Modo Prestador: input texto livre -->
                      <input 
                        *ngIf="selectedProvider && isThirdPartyOS()"
                        type="text" 
                        class="form-control form-control-sm" 
                        [(ngModel)]="peca.descricao"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="Nome da peça"
                        (input)="onPecaChange(i)"
                        [disabled]="isViewMode">
                      <!-- Modo Normal: dropdown da API -->
                      <select 
                        *ngIf="!selectedProvider || !isThirdPartyOS()"
                        class="form-control form-control-sm" 
                        [(ngModel)]="peca.descricao"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onPecaChange(i)"
                        [disabled]="isViewMode || loadingItems">
                        <option value="">{{ loadingItems ? 'Carregando itens...' : 'Selecione a peça' }}</option>
                        <option *ngFor="let item of itemsDisponiveis; trackBy: trackByItemDisponivel" [value]="item.name">
                          {{ item.name }}{{ item.description ? ' - ' + item.description : '' }}
                        </option>
                      </select>
                    </td>
                    <td *ngIf="isThirdPartyOS()">
                      <select
                        class="form-control form-control-sm"
                        [(ngModel)]="peca.maintenanceKind"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onPecaChange(i)"
                        [disabled]="isViewMode">
                        <option value="Corretiva">Corretiva</option>
                        <option value="Preventiva">Preventiva</option>
                      </select>
                    </td>
                    <td>
                      <input 
                        type="number" 
                        class="form-control form-control-sm" 
                        [(ngModel)]="peca.quantidade"
                        [ngModelOptions]="{standalone: true}"
                        min="1"
                        step="1"
                        (input)="onPecaChange(i)"
                        [disabled]="isViewMode">
                    </td>
                    <td>
                      <!-- Modo Prestador: valor editável -->
                      <input 
                        *ngIf="selectedProvider && isThirdPartyOS()"
                        type="number" 
                        class="form-control form-control-sm text-end" 
                        [(ngModel)]="peca.valorUnitario"
                        [ngModelOptions]="{standalone: true}"
                        step="0.01"
                        min="0"
                        placeholder="0,00"
                        (input)="onPecaChange(i)"
                        [disabled]="isViewMode || peca.maintenanceKind === 'Preventiva'">
                      <!-- Modo Normal: valor readonly -->
                      <input 
                        *ngIf="!selectedProvider || !isThirdPartyOS()"
                        type="number" 
                        class="form-control form-control-sm text-end form-control-readonly" 
                        [(ngModel)]="peca.valorUnitario"
                        [ngModelOptions]="{standalone: true}"
                        step="0.01"
                        min="0"
                        (input)="onPecaChange(i)"
                        [disabled]="true"
                        readonly
                        title="Valor unitário não editável">
                    </td>
                    <td *ngIf="canViewChargePercent">
                      <input
                        type="number"
                        class="form-control form-control-sm text-end"
                        [(ngModel)]="peca.chargePercent"
                        [ngModelOptions]="{standalone: true}"
                        min="0"
                        max="1000"
                        step="0.01"
                        placeholder="0"
                        (input)="onPecaChange(i)"
                        [disabled]="isViewMode || peca.maintenanceKind === 'Preventiva'">
                    </td>
                    <td class="text-end">
                      <strong [class.text-danger]="peca.isAvaria">{{ formatarValor(peca.valorTotal) }}</strong>
                    </td>
                    <td class="text-center">
                      <div class="avaria-toggle-container">
                        <label class="toggle-switch">
                          <input 
                            type="checkbox" 
                            [(ngModel)]="peca.isAvaria"
                            [ngModelOptions]="{standalone: true}"
                            (change)="onAvariaChange()"
                            [disabled]="isViewMode">
                          <span class="toggle-slider"></span>
                        </label>
                        <span class="avaria-label" *ngIf="peca.isAvaria">
                          <i class="fas fa-check-circle text-danger"></i>
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span *ngIf="peca.isAvaria" 
                            class="badge cursor-pointer"
                            [class.badge-warning]="peca.statusAvaria === 'Pendente'"
                            [class.badge-success]="peca.statusAvaria === 'Pago'"
                            (click)="alterarStatusAvariaPeca(i)"
                            title="Clique para alterar status de pagamento">
                        {{ peca.statusAvaria || 'Pendente' }}
                      </span>
                      <span *ngIf="!peca.isAvaria" class="text-muted">-</span>
                    </td>
                    <td class="text-center" *ngIf="canStockSection()">
                      <span class="badge" 
                            [class.badge-success]="peca.emEstoque"
                            [class.badge-danger]="!peca.emEstoque">
                        <i [class]="peca.emEstoque ? 'fas fa-check' : 'fas fa-times'"></i>
                        {{ peca.emEstoque ? 'Sim' : 'Não' }}
                      </span>
                    </td>
                    <td *ngIf="!isViewMode" class="text-center">
                      <button 
                        type="button" 
                        class="btn btn-danger btn-sm" 
                        (click)="removerPeca(i)"
                        title="Remover peça">
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="pecas.length === 0">
                    <td [attr.colspan]="isViewMode ? 8 : 9" class="text-center text-muted">
                      <i class="fas fa-info-circle"></i> Nenhuma peça adicionada
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-active">
                    <td colspan="4" class="text-end"><strong>Subtotal Peças:</strong></td>
                    <td class="text-end"><strong>{{ formatarValor(calcularValorTotalPecas()) }}</strong></td>
                    <td colspan="4" *ngIf="!isViewMode"></td>
                    <td colspan="3" *ngIf="isViewMode"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- SEÇÃO: Total Geral -->
        <div class="form-section">
          <div class="row">
            <!-- Coluna 1: Total Geral -->
            <div class="col-md-6">
              <div class="total-geral-container">
                <div class="total-geral-card">
                  <div class="total-geral-header">
                    <h4><i class="fas fa-calculator"></i> Total Geral</h4>
                  </div>
                  <div class="total-geral-content">
                    <div class="total-linha">
                      <span class="total-label">Subtotal Serviços:</span>
                      <span class="total-valor">{{ formatarValor(calcularValorTotalServicos()) }}</span>
                    </div>
                    <div class="total-linha">
                      <span class="total-label">Subtotal Peças:</span>
                      <span class="total-valor">{{ formatarValor(calcularValorTotalPecas()) }}</span>
                    </div>

                    <!-- Acréscimo % (somente OS de Terceiros) -->
                    <div class="acrescimo-container" *ngIf="isThirdPartyOS()">
                      <div class="acrescimo-toggle-row">
                        <label class="toggle-switch">
                          <input
                            type="checkbox"
                            [(ngModel)]="aplicarAcrescimo"
                            [ngModelOptions]="{standalone: true}"
                            (change)="onAplicarAcrescimoChange()"
                            [disabled]="isViewMode">
                          <span class="toggle-slider"></span>
                        </label>
                        <span class="acrescimo-toggle-label">Aplicar Acréscimo %</span>
                      </div>
                      <div class="acrescimo-input-row" *ngIf="aplicarAcrescimo">
                        <label class="acrescimo-input-label" for="acrescimoPercentual">Percentual (%):</label>
                        <input
                          id="acrescimoPercentual"
                          type="number"
                          class="form-control acrescimo-input"
                          min="0"
                          max="1000"
                          step="0.01"
                          [(ngModel)]="acrescimoPercentual"
                          [ngModelOptions]="{standalone: true}"
                          [disabled]="isViewMode"
                          placeholder="0,00">
                      </div>
                      <div class="total-linha" *ngIf="aplicarAcrescimo && acrescimoPercentual > 0">
                        <span class="total-label">Acréscimo ({{ acrescimoPercentual }}%):</span>
                        <span class="total-valor">{{ formatarValor(calcularValorAcrescimo()) }}</span>
                      </div>
                    </div>

                    <div class="total-linha total-final">
                      <span class="total-label"><strong>TOTAL GERAL:</strong></span>
                      <span class="total-valor"><strong>{{ formatarValor(calcularValorTotalGeral()) }}</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Coluna 2: Total de Avarias -->
            <div class="col-md-6">
              <div class="total-geral-container">
                <div class="total-avarias-card">
                  <div class="total-avarias-header">
                    <h4><i class="fas fa-exclamation-triangle"></i> Total de Avarias</h4>
                  </div>
                  <div class="total-avarias-content">
                    <div class="avarias-info" *ngIf="calcularQuantidadeAvarias() > 0">
                      <div class="avarias-quantidade">
                        <i class="fas fa-list-ol"></i>
                        <span>{{ calcularQuantidadeAvarias() }} item(s) marcado(s) como avaria</span>
                      </div>
                      <div class="avarias-detalhes">
                        <div class="total-linha">
                          <span class="total-label">Serviços com Avaria:</span>
                          <span class="total-valor text-danger">{{ formatarValor(calcularValorAvariasServicos()) }}</span>
                        </div>
                        <div class="total-linha">
                          <span class="total-label">Peças com Avaria:</span>
                          <span class="total-valor text-danger">{{ formatarValor(calcularValorAvariasPecas()) }}</span>
                        </div>
                        <div class="total-linha total-final-avarias">
                          <span class="total-label"><strong>TOTAL AVARIAS:</strong></span>
                          <span class="total-valor text-danger"><strong>{{ formatarValor(calcularValorTotalAvarias()) }}</strong></span>
                        </div>
                      </div>
                      <div class="avarias-action">
                        <button 
                          type="button" 
                          class="btn btn-danger btn-lg w-100" 
                          (click)="gerarBoletoAvarias()"
                          *ngIf="!isViewMode"
                          [disabled]="calcularValorTotalAvarias() === 0 || gerandoBoletoAvarias || boletoAvariasGerado">
                          <i class="fas fa-file-invoice-dollar"></i>
                          {{ gerandoBoletoAvarias ? 'Gerando...' : (boletoAvariasGerado ? 'Cobrança gerada' : 'Gerar Cobrança de Avarias') }}
                        </button>
                      </div>
                    </div>
                    <div class="avarias-empty" *ngIf="calcularQuantidadeAvarias() === 0">
                      <i class="fas fa-info-circle"></i>
                      <p>Nenhum item marcado como avaria</p>
                      <small>Utilize os sliders nas tabelas acima para marcar itens como avaria</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SEÇÃO: Salvar Sessão de Trabalho -->
        <div class="form-section" *ngIf="!isViewMode">
          <div class="save-session-container">
            <div class="save-session-header">
              <div class="save-session-info">
                <i class="fas fa-save"></i>
                <div>
                  <h4>{{ isThirdPartyOS() ? 'Gerar Orçamento' : 'Salvar Serviço(s)' }}</h4>
                  <p *ngIf="!isThirdPartyOS()">Salve os serviços e peças atuais como uma sessão de trabalho com a data de realização</p>
                  <p *ngIf="isThirdPartyOS()">Gere um orçamento com os serviços e peças atuais para envio ao cliente</p>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-lg"
                (click)="salvarSessaoTrabalho()"
                [disabled]="salvandoSessaoTrabalho">
                <i class="fas" [class.fa-save]="!isEditandoSessao()" [class.fa-edit]="isEditandoSessao()"></i>
                <ng-container *ngIf="isEditandoSessao(); else novoBlock">
                  {{ salvandoSessaoTrabalho ? 'Salvando Revisão...' : 'Salvar Revisão' }}
                </ng-container>
                <ng-template #novoBlock>
                  <ng-container *ngIf="isThirdPartyOS(); else saveLabel">
                    {{ salvandoSessaoTrabalho ? 'Gerando...' : 'Gerar Orçamento' }}
                  </ng-container>
                  <ng-template #saveLabel>
                    {{ salvandoSessaoTrabalho ? 'Salvando...' : 'Salvar Serviço(s)' }}
                  </ng-template>
                </ng-template>
              </button>
              <button
                *ngIf="isEditandoSessao()"
                type="button"
                class="btn btn-lg btn-secondary"
                style="margin-left: 10px;"
                (click)="cancelarEdicaoSessao()"
                [disabled]="salvandoSessaoTrabalho">
                <i class="fas fa-times"></i> Cancelar Edição
              </button>
            </div>
          </div>
        </div>

        <!-- SEÇÃO: Histórico de Serviços -->
        <div class="form-section" *ngIf="sessoesTrabalho.length > 0">
          <h3 class="section-title">
            <i class="fas fa-history"></i> Histórico de Serviços
          </h3>
          
          <div class="sessoes-container">
            <div class="sessao-card" *ngFor="let sessao of sessoesTrabalho; let i = index; trackBy: trackBySessaoTrabalho">
              <div class="sessao-header">
                <div class="sessao-info">
                  <div class="sessao-numero">
                    <i class="fas fa-folder"></i>
                    <span>Serviço #{{ i + 1 }}</span>
                  </div>
                  <div class="sessao-data">
                    <i class="fas fa-calendar-alt"></i>
                    <span>{{ formatarDataHora(sessao.dataSessao) }}</span>
                  </div>
                </div>
                <div class="sessao-aprovacao">
                  <div class="sessao-pendente-badge"
                       [class.sessao-cancelada-badge]="isSessaoCancelada(sessao)"
                       [class.sessao-pendente-pagamento-badge]="isSessaoPendentePagamento(sessao)">
                    <i class="fas"
                       [class.fa-info-circle]="!isSessaoCancelada(sessao) && !isSessaoPendentePagamento(sessao)"
                       [class.fa-ban]="isSessaoCancelada(sessao)"
                       [class.fa-money-bill-wave]="isSessaoPendentePagamento(sessao)"></i>
                    <span>Status: {{ getSessaoStatus(sessao) }}</span>
                  </div>
                  <div style="width: 10px;" *ngIf="isThirdPartyOS() && isSessaoEmRevisao(sessao)"></div>
                  <button
                    *ngIf="isThirdPartyOS() && isSessaoEmRevisao(sessao)"
                    type="button"
                    class="btn btn-warning"
                    (click)="editarSessaoEmRevisao(sessao, i)"
                    [disabled]="editingWorkSectionId !== null || salvandoSessaoTrabalho"
                    title="Editar valores deste orçamento e enviar novamente para aprovação">
                    <i class="fas fa-edit"></i>
                    {{ editingWorkSectionId === sessao.id ? 'Editando...' : 'Editar Valores' }}
                  </button>
                </div>
              </div>

              <div class="sessao-content">
                <!-- Serviços da Sessão -->
                <div class="sessao-servicos" *ngIf="sessao.servicos.length > 0">
                  <h5><i class="fas fa-wrench"></i> Serviços ({{ sessao.servicos.length }})</h5>
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th>Descrição</th>
                        <th width="10%">Qtd</th>
                        <th width="15%">Valor Unit.</th>
                        <th width="15%">Total</th>
                        <th width="10%" class="text-center">Avaria</th>
                        <th width="10%" class="text-center">Status Pagamento</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let servico of sessao.servicos; let idx = index; trackBy: trackBySessaoServico" [class.avaria-row]="servico.isAvaria">
                        <td class="text-center">{{ idx + 1 }}</td>
                        <td>
                          {{ servico.descricao }}
                          <span *ngIf="servico.isGuincho" class="badge ms-1" style="background:#cfe2ff;color:#084298;">Guincho</span>
                        </td>
                        <td class="text-center">{{ servico.quantidade }}</td>
                        <td class="text-end">{{ formatarValor(servico.valorUnitario) }}</td>
                        <td class="text-end"><strong>{{ formatarValor(valorLinhaCobranca(servico)) }}</strong></td>
                        <td class="text-center">
                          <button type="button"
                                  class="btn btn-sm btn-link p-0 avaria-sessao-toggle"
                                  *ngIf="!isViewMode"
                                  [disabled]="atualizandoAvariaSessao"
                                  (click)="alternarAvariaSessaoServico(servico)"
                                  title="Clique para marcar/desmarcar avaria">
                            <span *ngIf="servico.isAvaria" class="badge badge-danger">
                              <i class="fas fa-exclamation-triangle"></i> Sim
                            </span>
                            <span *ngIf="!servico.isAvaria" class="badge badge-light text-muted">Não</span>
                          </button>
                          <ng-container *ngIf="isViewMode">
                            <span *ngIf="servico.isAvaria" class="badge badge-danger">
                              <i class="fas fa-exclamation-triangle"></i> Sim
                            </span>
                            <span *ngIf="!servico.isAvaria" class="text-muted">Não</span>
                          </ng-container>
                        </td>
                        <td class="text-center">
                          <span *ngIf="servico.statusAvaria" 
                                class="badge"
                                [class.badge-warning]="servico.statusAvaria === 'Pendente'"
                                [class.badge-success]="servico.statusAvaria === 'Pago'">
                            {{ servico.statusAvaria }}
                          </span>
                          <span *ngIf="!servico.statusAvaria" class="text-muted">-</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="table-active">
                        <td colspan="4" class="text-end"><strong>Subtotal:</strong></td>
                        <td class="text-end"><strong>{{ formatarValor(calcularSubtotalServicos(sessao.servicos)) }}</strong></td>
                        <td colspan="2"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <!-- Peças da Sessão -->
                <div class="sessao-pecas" *ngIf="sessao.pecas.length > 0">
                  <h5><i class="fas fa-cogs"></i> Peças ({{ sessao.pecas.length }})</h5>
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th>Descrição</th>
                        <th width="10%">Qtd</th>
                        <th width="15%">Valor Unit.</th>
                        <th width="15%">Total</th>
                        <th width="10%" class="text-center">Avaria</th>
                        <th width="10%" class="text-center">Status Pagamento</th>
                        <th width="10%" class="text-center" *ngIf="canStockSection()">Em Estoque</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let peca of sessao.pecas; let idx = index; trackBy: trackBySessaoPeca" [class.avaria-row]="peca.isAvaria">
                        <td class="text-center">{{ idx + 1 }}</td>
                        <td>{{ peca.descricao }}</td>
                        <td class="text-center">{{ peca.quantidade }}</td>
                        <td class="text-end">{{ formatarValor(peca.valorUnitario) }}</td>
                        <td class="text-end"><strong>{{ formatarValor(valorLinhaCobranca(peca)) }}</strong></td>
                        <td class="text-center">
                          <button type="button"
                                  class="btn btn-sm btn-link p-0 avaria-sessao-toggle"
                                  *ngIf="!isViewMode"
                                  [disabled]="atualizandoAvariaSessao"
                                  (click)="alternarAvariaSessaoPeca(peca)"
                                  title="Clique para marcar/desmarcar avaria">
                            <span *ngIf="peca.isAvaria" class="badge badge-danger">
                              <i class="fas fa-exclamation-triangle"></i> Sim
                            </span>
                            <span *ngIf="!peca.isAvaria" class="badge badge-light text-muted">Não</span>
                          </button>
                          <ng-container *ngIf="isViewMode">
                            <span *ngIf="peca.isAvaria" class="badge badge-danger">
                              <i class="fas fa-exclamation-triangle"></i> Sim
                            </span>
                            <span *ngIf="!peca.isAvaria" class="text-muted">Não</span>
                          </ng-container>
                        </td>
                        <td class="text-center">
                          <span *ngIf="peca.statusAvaria" 
                                class="badge"
                                [class.badge-warning]="peca.statusAvaria === 'Pendente'"
                                [class.badge-success]="peca.statusAvaria === 'Pago'">
                            {{ peca.statusAvaria }}
                          </span>
                          <span *ngIf="!peca.statusAvaria" class="text-muted">-</span>
                        </td>
                        <td class="text-center" *ngIf="canStockSection()">
                          <span class="badge" 
                                [class.badge-success]="peca.emEstoque"
                                [class.badge-danger]="!peca.emEstoque">
                            <i [class]="peca.emEstoque ? 'fas fa-check' : 'fas fa-times'"></i>
                            {{ peca.emEstoque ? 'Sim' : 'Não' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="table-active">
                        <td colspan="4" class="text-end"><strong>Subtotal:</strong></td>
                        <td class="text-end"><strong>{{ formatarValor(calcularSubtotalPecas(sessao.pecas)) }}</strong></td>
                        <td colspan="3"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <!-- Total da Sessão -->
                <div class="sessao-total">
                  <div class="total-sessao-row">
                    <span class="total-label">Total da Sessão:</span>
                    <span class="total-valor">{{ formatarValor(sessao.valorTotal) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- STEP 6: Anexos -->
        <div *ngIf="currentStep === 6" class="step-content">
        <!-- SEÇÃO: Anexos -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-paperclip"></i> Anexos da OS
            <small style="font-size: 0.8rem; font-weight: normal; color: #6c757d; margin-left: 1rem;">
              (Documentos, fotos e outros arquivos)
            </small>
          </h3>
          
          <!-- Formulário para adicionar anexo (também em visualizar — provas operacionais). -->
          <div class="anexo-form-container" *ngIf="serviceOrderId">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="tipoAnexo">Tipo do Documento <span class="required">*</span></label>
                  <select 
                    id="tipoAnexo" 
                    class="form-control"
                    [(ngModel)]="novoAnexo.tipo"
                    [ngModelOptions]="{standalone: true}">
                    <option [ngValue]="undefined" disabled>Selecione o tipo</option>
                    <option *ngFor="let tipo of tiposAnexo; trackBy: trackByTipoAnexo" [ngValue]="tipo">{{ tipo }}</option>
                  </select>
                </div>
              </div>
              
              <div class="col-md-5">
                <div class="form-group">
                  <label for="descricaoAnexo">Descrição (opcional)</label>
                  <input 
                    type="text" 
                    id="descricaoAnexo" 
                    class="form-control"
                    [(ngModel)]="novoAnexo.descricao"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Ex: Foto do para-choque dianteiro">
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="form-group">
                  <label for="fileInput">Selecionar Arquivo <span class="required">*</span></label>
                  <div class="file-input-wrapper">
                    <input 
                      type="file" 
                      id="fileInput" 
                      class="file-input-hidden"
                      (change)="onFileSelected($event)"
                      accept=".pdf,.png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx"
                      #fileInput>
                    <button 
                      type="button" 
                      class="btn btn-outline-secondary btn-file-select" 
                      (click)="fileInput.click()">
                      <i class="fas fa-upload"></i>
                      {{ novoAnexo.nomeArquivo ? 'Alterar Arquivo' : 'Escolher Arquivo' }}
                    </button>
                    <div class="file-selected-info" *ngIf="novoAnexo.nomeArquivo">
                      <small class="text-success">
                        <i class="fas fa-check-circle"></i> {{ novoAnexo.nomeArquivo }}
                      </small>
                    </div>
                    <button 
                      type="button" 
                      class="btn btn-success btn-adicionar-anexo" 
                      (click)="adicionarAnexo()"
                      [disabled]="!novoAnexo.tipo || !novoAnexo.arquivo">
                      <i class="fas fa-plus"></i> Adicionar Anexo
                    </button>
                  </div>
                  <small class="form-text text-muted">
                    <i class="fas fa-info-circle"></i> Formatos: PDF, PNG, JPG, DOC, XLS (máx. 10MB)
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="anexo-form-container" *ngIf="!serviceOrderId">
            <div class="alert alert-info mb-0">
              <i class="fas fa-info-circle"></i>
              Salve a OS primeiro para poder anexar documentos e fotos.
            </div>
          </div>

          <!-- Lista de anexos -->
          <div class="anexos-list-container" *ngIf="anexos.length > 0">
            <div class="table-responsive">
              <table class="table table-hover anexos-table">
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Nome do Arquivo</th>
                    <th>Descrição</th>
                    <th>Tamanho</th>
                    <th>Adicionado por</th>
                    <th>Data</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let anexo of anexos; trackBy: trackByAnexo">
                    <td>
                      <span class="badge" [class]="getBadgeClassAnexo(anexo.tipo)">
                        <i [class]="getIconeAnexo(anexo.tipo)"></i>
                        {{ anexo.tipo }}
                      </span>
                    </td>
                    <td>
                      <div class="arquivo-info">
                        <i [class]="getIconeArquivo(anexo.nomeArquivo)"></i>
                        <span>{{ anexo.nomeArquivo }}</span>
                      </div>
                    </td>
                    <td>
                      <small class="text-muted">{{ anexo.descricao || '-' }}</small>
                    </td>
                    <td>
                      <small>{{ formatarTamanhoArquivo(anexo.tamanho) }}</small>
                    </td>
                    <td>
                      <small class="text-muted">
                        <i class="fas fa-user"></i> {{ anexo.usuarioAdicionou }}
                      </small>
                    </td>
                    <td>
                      <small class="text-muted">
                        <i class="fas fa-clock"></i> {{ formatarDataHora(anexo.dataAdicao) }}
                      </small>
                    </td>
                    <td>
                      <div class="btn-group btn-group-sm" role="group">
                        <button 
                          type="button" 
                          class="btn btn-primary btn-xs" 
                          (click)="visualizarAnexo(anexo)"
                          title="Visualizar">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-success btn-xs" 
                          (click)="baixarAnexo(anexo)"
                          title="Baixar">
                          <i class="fas fa-download"></i>
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-danger btn-xs" 
                          (click)="removerAnexo(anexo.id!)"
                          title="Remover">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div class="anexos-summary">
              <strong>
                <i class="fas fa-paperclip"></i>
                Total: {{ anexos.length }} anexo(s) | 
                Tamanho total: {{ formatarTamanhoArquivo(calcularTamanhoTotalAnexos()) }}
              </strong>
            </div>
          </div>

          <!-- Estado vazio -->
          <div class="anexos-empty" *ngIf="anexos.length === 0">
            <div class="empty-state">
              <i class="fas fa-paperclip"></i>
              <h4>Nenhum anexo adicionado</h4>
              <p>Adicione fotos de avarias, documentos adicionais ou outros arquivos relevantes</p>
            </div>
          </div>
        </div>
        </div>

        <!-- STEP 7: Histórico e Observações -->
        <div *ngIf="currentStep === 7" class="step-content">
        <!-- SEÇÃO: Histórico de Movimentações -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-history"></i> Histórico de Movimentações
            <button 
              type="button" 
              class="btn btn-sm btn-info ms-auto" 
              (click)="carregarHistoricoMockado()"
              *ngIf="historico.length === 0"
              title="Carregar histórico de exemplo">
              <i class="fas fa-flask"></i> Carregar Exemplo
            </button>
          </h3>

          <!-- Filtro de Data -->
          <div class="historico-filtro-container" *ngIf="historico.length > 0">
            <div class="filtro-header">
              <div class="filtro-icon">
                <i class="fas fa-filter"></i>
              </div>
              <h5>Filtrar por Data</h5>
            </div>
            <div class="filtro-campos">
              <div class="filtro-campo">
                <label for="filtroDataInicio">
                  <i class="fas fa-calendar-day"></i>
                  Data Início
                </label>
                <input 
                  type="date" 
                  id="filtroDataInicio" 
                  class="form-control form-control-sm"
                  [(ngModel)]="filtroDataInicio"
                  [ngModelOptions]="{standalone: true}"
                  (change)="onHistoricoFiltroChange()">
              </div>
              <div class="filtro-campo">
                <label for="filtroDataFim">
                  <i class="fas fa-calendar-check"></i>
                  Data Fim
                </label>
                <input 
                  type="date" 
                  id="filtroDataFim" 
                  class="form-control form-control-sm"
                  [(ngModel)]="filtroDataFim"
                  [ngModelOptions]="{standalone: true}"
                  (change)="onHistoricoFiltroChange()">
              </div>
              <div class="filtro-acoes">
                <button 
                  type="button" 
                  class="btn btn-sm btn-primary"
                  (click)="onHistoricoFiltroChange()"
                  [disabled]="!filtroDataInicio && !filtroDataFim">
                  <i class="fas fa-search"></i>
                  Filtrar
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm btn-secondary"
                  (click)="onHistoricoFiltroClear()"
                  [disabled]="!filtroDataInicio && !filtroDataFim">
                  <i class="fas fa-times"></i>
                  Limpar
                </button>
              </div>
            </div>
            <div class="filtro-info" *ngIf="filtroDataInicio || filtroDataFim">
              <i class="fas fa-info-circle"></i>
              <span>
                Mostrando {{ historicoFiltrado.length }} de {{ historico.length }} registro(s)
              </span>
            </div>
          </div>
          
          <div class="historico-timeline" *ngIf="historicoFiltrado.length > 0">
            <div class="timeline-item" *ngFor="let evento of historicoFiltrado; let i = index; trackBy: trackByHistorico">
              <div class="timeline-marker" [style.background-color]="getCorEvento(evento.tipo)">
                <i [class]="getIconeEvento(evento.tipo)"></i>
              </div>
              <div class="timeline-content">
                <div class="timeline-header">
                  <h4 class="timeline-title">{{ evento.acao }}</h4>
                  <span class="timeline-date">
                    <i class="fas fa-clock"></i> {{ formatarDataHora(evento.dataHora) }}
                  </span>
                </div>
                <div class="timeline-body">
                  <p class="timeline-usuario">
                    <i class="fas fa-user"></i> <strong>{{ evento.usuarioNome }}</strong>
                  </p>
                  <p class="timeline-detalhes" *ngIf="evento.detalhes">
                    {{ evento.detalhes }}
                  </p>
                  <div class="timeline-badges" *ngIf="evento.setorAtual || evento.setorOrigem || evento.setorDestino || evento.statusAnterior || evento.statusNovo">
                    <span class="badge" *ngIf="evento.setorAtual" style="background-color: #3A4D56; color: white; margin-right: 0.5rem;">
                      <i class="fas fa-building"></i> Setor Atual: {{ evento.setorAtual }}
                    </span>
                    <span class="badge badge-secondary" *ngIf="evento.setorOrigem">
                      <i class="fas fa-map-marker-alt"></i> De: {{ evento.setorOrigem }}
                    </span>
                    <span class="badge badge-primary" *ngIf="evento.setorDestino">
                      <i class="fas fa-map-marker-alt"></i> Para: {{ evento.setorDestino }}
                    </span>
                    <span class="badge badge-warning" *ngIf="evento.statusAnterior">
                      <i class="fas fa-arrow-right"></i> {{ evento.statusAnterior }}
                    </span>
                    <span class="badge badge-success" *ngIf="evento.statusNovo">
                      <i class="fas fa-check"></i> {{ evento.statusNovo }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="historico-empty" *ngIf="historicoFiltrado.length === 0 && historico.length > 0">
            <i class="fas fa-filter"></i>
            <p>Nenhum registro encontrado no período selecionado</p>
            <small>Tente ajustar o filtro de datas para visualizar mais eventos</small>
          </div>

          <div class="historico-empty" *ngIf="historico.length === 0">
            <i class="fas fa-history"></i>
            <p>Nenhum evento registrado ainda</p>
            <small>Os eventos serão registrados automaticamente conforme a OS for movimentada</small>
          </div>

        </div>
        </div>

        <!-- STEP 8: CheckList -->
        <div *ngIf="currentStep === 8" class="step-content">
        <!-- SEÇÃO: CheckList -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-tasks"></i> CheckList da OS
            <small style="font-size: 0.8rem; font-weight: normal; color: #6c757d; margin-left: 1rem;">
              (Documentos PDF de verificação e checklist)
            </small>
          </h3>
          
          <!-- Informações sobre CheckList -->
          <div class="checklist-info-container">
            <div class="checklist-actions-card">
              <div class="alert alert-info checklist-info-alert">
                <i class="fas fa-info-circle"></i>
                <div>
                  <strong>CheckLists da OS:</strong> Visualize e baixe os PDFs de checklist do veículo vinculado. Para criar um novo, clique em <strong>Novo Checklist</strong> e selecione o tipo (Inspeção, Preventiva, Recolhimento, etc.) — a placa da OS será pré-preenchida automaticamente.
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary checklist-new-button"
                (click)="abrirNovoChecklist()">
                <i class="fas fa-plus"></i>
                Novo Checklist
              </button>
            </div>
          </div>

          <!-- Loading -->
          <div *ngIf="loadingVehicleChecklists" class="text-center py-3">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
            <div class="text-muted mt-2">Carregando checklists do veículo...</div>
          </div>

          <!-- Erro -->
          <div class="alert alert-warning" *ngIf="!loadingVehicleChecklists && vehicleChecklistsLoadError">
            <i class="fas fa-exclamation-triangle"></i>
            {{ vehicleChecklistsLoadError }}
          </div>

          <!-- Lista de checklists (por placa) -->
          <div class="checklists-list-container" *ngIf="!loadingVehicleChecklists && !vehicleChecklistsLoadError && vehicleChecklists.length > 0">
            <div class="table-responsive">
              <table class="table table-hover checklists-table">
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>KM Painel</th>
                    <th>Status</th>
                    <th>Data/Hora</th>
                    <th>Condutor</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let checklist of vehicleChecklists; trackBy: trackByVehicleChecklist">
                    <td>
                      <span class="badge badge-primary">
                        <i class="fas fa-tasks"></i>
                        {{ getChecklistTypeDisplay(checklist) }}
                      </span>
                    </td>
                    <td>
                      <small>
                        <i class="fas fa-tachometer-alt"></i>
                        {{ checklist.DashboardMileage }}
                      </small>
                    </td>
                    <td>
                      <span class="badge" [class]="getChecklistStatusBadgeClass(checklist.Status)">
                        {{ checklist.Status || '-' }}
                      </span>
                    </td>
                    <td>
                      <small class="text-muted">
                        <i class="fas fa-clock"></i>
                        {{ formatarDataHora(checklist.ChecklistDate) }}
                      </small>
                    </td>
                    <td>
                      <small class="text-muted">
                        <i class="fas fa-user"></i>
                        {{ checklist.DriverName || '-' }}
                      </small>
                    </td>
                    <td>
                      <div class="btn-group btn-group-sm" role="group">
                        <button
                          type="button"
                          class="btn btn-primary btn-xs"
                          (click)="visualizarVehicleChecklist(checklist)"
                          [disabled]="!getVehicleChecklistPdfUrlRaw(checklist)"
                          title="Visualizar PDF">
                          <i class="fas fa-eye"></i>
                          <span class="d-none d-sm-inline ms-1">Ver</span>
                        </button>
                        <button
                          type="button"
                          class="btn btn-success btn-xs"
                          (click)="baixarVehicleChecklistPdf(checklist)"
                          [disabled]="!getVehicleChecklistPdfUrlRaw(checklist)"
                          title="Baixar PDF">
                          <i class="fas fa-download"></i>
                          <span class="d-none d-sm-inline ms-1">Baixar</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Estado vazio -->
          <div class="checklists-empty" *ngIf="!loadingVehicleChecklists && !vehicleChecklistsLoadError && vehicleChecklists.length === 0">
            <div class="empty-state">
              <i class="fas fa-tasks"></i>
              <h4>Nenhum checklist encontrado</h4>
              <p>Não há checklists retornados para a placa do veículo vinculada a esta OS</p>
            </div>
          </div>

          <!-- Visualizador de PDF -->
          <div class="pdf-viewer-container" *ngIf="vehicleChecklistSelecionado">
            <div class="pdf-viewer-header">
              <h4>
                <i class="fas fa-file-pdf text-danger"></i>
                {{ getChecklistTypeDisplay(vehicleChecklistSelecionado) }}
                <span class="badge ms-2" [class]="getChecklistStatusBadgeClass(vehicleChecklistSelecionado.Status)">
                  {{ vehicleChecklistSelecionado.Status || '-' }}
                </span>
              </h4>
              <div class="pdf-viewer-info">
                <small class="text-muted">
                  <i class="fas fa-user"></i> {{ vehicleChecklistSelecionado.DriverName || '-' }}
                  <span class="mx-2">|</span>
                  <i class="fas fa-clock"></i> {{ formatarDataHora(vehicleChecklistSelecionado.ChecklistDate) }}
                </small>
              </div>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                (click)="fecharVehicleChecklistVisualizadorPDF()">
                <i class="fas fa-times"></i> Fechar
              </button>
            </div>
            <div class="pdf-viewer-content">
              <iframe
                [src]="getVehicleChecklistPdfUrl(vehicleChecklistSelecionado)"
                width="100%"
                height="600px"
                style="border: 1px solid #dee2e6; border-radius: 8px;">
                Seu navegador não suporta visualização de PDF.
                <a [href]="getVehicleChecklistPdfUrlRaw(vehicleChecklistSelecionado)" target="_blank">Clique aqui para baixar</a>
              </iframe>
            </div>
          </div>
        </div>
        </div>

        <!-- INDICADOR DA ABA ATIVA -->
        <div class="tab-indicator">
          <i class="fas fa-folder-open"></i>
          <span>{{ getCurrentTabName() }}</span>
        </div>

        <!-- AÇÕES DO FORMULÁRIO (SEMPRE VISÍVEIS) -->
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="onCancel()">
            <i class="fas fa-times"></i>
            Cancelar
          </button>
          

          
          <button 
            *ngIf="!isViewMode" 
            type="submit" 
            class="btn btn-primary" 
            [disabled]="submitting || (!osGerada && !serviceOrderId)">
            <i class="fas fa-save"></i>
            {{ submitting ? (serviceOrderId ? 'Atualizando...' : 'Salvando...') : (serviceOrderId ? 'Salvar Alterações' : 'Salvar') }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Modais de Seleção -->
  <app-customer-selection-modal 
    #customerModal
    (customerSelected)="onCustomerSelected($event)">
  </app-customer-selection-modal>

  <app-vehicle-selection-modal 
    #vehicleModal
    (vehicleSelected)="onVehicleSelected($event)">
  </app-vehicle-selection-modal>


  <app-direcionamento-modal
    #direcionamentoModal
    (direcionamentoConfirmado)="onDirecionamentoConfirmado($event)">
  </app-direcionamento-modal>

  <app-service-order-close-modal
    #encerramentoModal
    (encerramentoConfirmado)="onEncerramentoConfirmado($event)">
  </app-service-order-close-modal>

  <app-warehouse-selection-modal 
    #warehouseModal
    (warehouseSelected)="onWarehouseSelected($event)">
  </app-warehouse-selection-modal>

  <app-provider-selection-modal
    #providerModal
    (providerSelected)="onProviderSelected($event)">
  </app-provider-selection-modal>

  <app-vehicle-selection-modal 
    #vehicleAdditionalModal
    (vehicleSelected)="onVehicleAdditionalSelected($event)">
  </app-vehicle-selection-modal>

</app-side-menu>